export default {
  Parking: {
    icon: "fa fa-car",
    abbr: "PK",
    routeName: "parking",
    bgColor: "bg-brown-400",
    name: "Parking"
  },
  Markets: {
    icon: "fa fa-shopping-bag",
    abbr: "MK",
    routeName: "markets",
    bgColor: "m--bg-accent",
    name: "Markets"
  },
  Advertising: {
    icon: "fa fa-bullhorn",
    abbr: "AD",
    routeName: "advertising",
    bgColor: "bg-green-400",
    name: "Advertising"
  },
  HouseRent: {
    icon: "fa fa-home",
    abbr: "HR",
    routeName: "houseRent",
    bgColor: "bg-indigo-400",
    name: "House Rent"
  },
  LandRates: {
    icon: "fa fa-building",
    abbr: "LR",
    routeName: "landRates",
    bgColor: "bg-grey-400",
    name: "Land Rates"
  },
  Licenses: {
    icon: "fa fa-list",
    abbr: "LI",
    routeName: "licenses",
    bgColor: "bg-blue-400",
    name: "Licenses"
  },
  ParkServices: {
    icon: "fa fa-industry",
    abbr: "PS",
    routeName: "parkServices",
    bgColor: "bg-red-400",
    name: "Park Services"
  },
  Cess: {
    icon: "fa fa-list",
    abbr: "CS",
    routeName: "cess",
    bgColor: "bg-blue-400",
    name: "Cess"
  },
  Unclamping: {
    icon: "fa fa-cogs",
    abbr: "CS",
    routeName: "unclamping",
    bgColor: "bg-blue-400",
    name: "Unclamping"
  },
  Periodic: {
    icon: "fa fa-car",
    abbr: "SP",
    routeName: "seasonalParking",
    bgColor: "bg-purple-400",
    name: "Seasonal Parking"
  },
  VetFees: {
    icon: "fa fa-briefcase",
    abbr: "SBP",
    routeName: "sbp",
    bgColor: "bg-teal-400",
    name: "Business Permits"
  },
  SBP: {
    icon: "fa fa-briefcase",
    abbr: "SBP",
    routeName: "sbp",
    bgColor: "bg-teal-400",
    name: "Business Permits"
  }
};



// WEBPACK FOOTER //
// ./src/config/services.js